import SlotRuleVIew from "./slot_rule_view";
import Module, { moduleInit, bindButtonClickEvent, ViewLayer } from "../../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../../framework/core/module_manager";
import SlotTableSound from "../table/slot_table_sound"
const { ccclass, property } = cc._decorator;

@ccclass
@moduleInit('SlotRuleModule')
export default class SlotRuleModule extends Module<SlotRuleVIew, null> {

    pageIndex: number
    pageNumber: number

    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/slot/slot_rule";
        this.viewType = SlotRuleVIew;
        this.modelType = null;
        this.needAnim = false
        this.needViewMask = true
        this.clickAnywhereClose = false
    }

    protected onButtonClickName(name: string) {

        switch (name) {
            

            default:
                break;
        }
    }
    @bindButtonClickEvent("BtnClose", true)
    onbtnClose(node) {
        SlotTableSound.playBtnClickSound(node.name)
        this.hide()
    }
    @bindButtonClickEvent("BtnLeft", true)
    onbtnLeft(node) {
        SlotTableSound.playBtnClickSound(node.name)
        if (this.pageIndex > 0) {
            this.view.pageView.setCurrentPageIndex(this.pageIndex - 1)
            this.pageIndex = this.view.pageView.getCurrentPageIndex()
        }
        this.view.arrowBtnDeal(this.pageIndex, this.pageNumber)
    }
    @bindButtonClickEvent("BtnRight", true)
    onbtnRight(node) {
        SlotTableSound.playBtnClickSound(node.name)
        if (this.pageIndex < this.pageNumber - 1) {
            this.view.pageView.setCurrentPageIndex(this.pageIndex + 1)
            this.pageIndex = this.view.pageView.getCurrentPageIndex()
        }
        this.view.arrowBtnDeal(this.pageIndex, this.pageNumber)
    }

    onInit() {


    }

    onShow() {
        let self = this
        this.pageIndex = this.view.pageView.getCurrentPageIndex()
        this.pageNumber = this.view.pageView.getPages().length
        this.view.arrowBtnDeal(this.pageIndex, this.pageNumber)
        this.view.pageView.node.on('page-turning', function(){
            self.pageIndex = self.view.pageView.getCurrentPageIndex()
            self.view.arrowBtnDeal(self.pageIndex, self.pageNumber)
        }, this);
    }




}
